import { render, staticRenderFns } from "./HandClap.vue?vue&type=template&id=01ce6255&scoped=true&"
import script from "./HandClap.vue?vue&type=script&lang=js&"
export * from "./HandClap.vue?vue&type=script&lang=js&"
import style0 from "./HandClap.vue?vue&type=style&index=0&id=01ce6255&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ce6255",
  null
  
)

export default component.exports